import React, { Component } from "react"
import PropTypes from "prop-types"
import moment from "moment"

import { PootsyButton } from "./FunctionalDesign"

export default class WeekPicker extends Component {
	goToPrevWeek = () => {
		let { name, onChange, currentDate } = this.props
		let newWeek = moment(currentDate, "YYYY-MM-DD")
		newWeek.subtract(1, "week")
		onChange({ [name]: newWeek })
	}
	goToNextWeek = () => {
		let { name, onChange, currentDate } = this.props
		let newWeek = moment(currentDate, "YYYY-MM-DD")
		newWeek.add(1, "week")
		onChange({ [name]: newWeek })
	}
	goToCurrentWeek = () => {
		let { name, onChange } = this.props
		let newWeek = moment()
		onChange({ [name]: newWeek })
	}
	render() {
		let { t } = this.context
		let { disabled = false } = this.props
		return (
			<div className="pootsy-week-picker">
				<PootsyButton text="<" onClick={this.goToPrevWeek} disabled={disabled} />
				<PootsyButton
					text={t("agenda_go_to_current_week")}
					onClick={this.goToCurrentWeek}
					disabled={disabled}
				/>
				<PootsyButton text=">" onClick={this.goToNextWeek} disabled={disabled} />
			</div>
		)
	}
}

WeekPicker.contextTypes = { t: PropTypes.func }
